import React, {useEffect, useState} from 'react'
import i18n from 'i18next'
import actions from 'redux-auto'
import Api from '#services/api'
import Headline from '#components/a/Headline'
import PageHeader from '#components/m/PageHeader'
import {Courses} from '#components/m/Wissensportal/Courses'
import {Modules} from '#components/m/Wissensportal/Modules'

export default function WissensportalAzubi(props) {
  const [courses, setCourses] = useState([])
  const [selectedCourse, setSelectedCourse] = useState({})
  const [anyCourseIsSelected, setAnyCourseIsSelected] = useState(false)

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const coursesFromApi = await Api.getAllCourses()
        setCourses(coursesFromApi)
      } catch (e) {
        actions.error.writeError({error: e})
      }
    }
    fetchCourses()
  }, [])

  const onCourseClick = course => {
    if (courseIsSelected(course)) {
      deselectCourse()
    } else {
      selectCourse(course)
    }
  }

  const courseIsSelected = course => {
    return selectedCourse.id === course.id
  }

  const deselectCourse = () => {
    setSelectedCourse({})
    setAnyCourseIsSelected(false)
  }

  const selectCourse = course => {
    setSelectedCourse(course)
    setAnyCourseIsSelected(true)
  }

  return (
    <div className="wissensportal">
      <PageHeader
        headline={<Headline importance={2} modifier="section" text={i18n.t('wissensportal')} />}
        button={
          <a
            className="link link--primaryLight"
            href="https://verbund.edeka/karriere/karrierem%C3%B6glichkeiten/f%C3%BCr-mitarbeiter/digitales-lernen/edeka-next/"
            target="_blank"
            rel="noopener noreferrer">
            {i18n.t('wissensportal_navigate')}
          </a>
        }
      />
      <div className="wissensportal__content-wrapper">
        <Headline importance={1} modifier="category" text={i18n.t('wissensportal_my_curriculumn')} />

        <div className="course-module__wrapper">
          <Courses
            courses={courses}
            selectedCourseId={selectedCourse.id}
            onCourseClick={onCourseClick}
            mode="default"
          />
          {anyCourseIsSelected && <Modules modules={selectedCourse.modules} />}
        </div>
      </div>
    </div>
  )
}
